import React, {useEffect} from "react";
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';

ReactGA.initialize('G-4VVSCRJ7Z5');

const ReactGATracker = () => {
  const location = useLocation()

  useEffect(() => {
    // Skip login/root page
    if (
      location.pathname === '/' ||
      location.pathname === '/login'
    ) {
        console.log('GA SKIPPED')
      return
    }
    console.log('GA TRACKED')
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
    })

    console.log('GA Page View:', location.pathname)
  }, [location])

  return null
}

export default ReactGATracker